import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import {AuthProvider, useAuth} from "./context/AuthContext";
import Dashboard from "./pages/Dashboard";
import Members from "./pages/Members";
import Contributions from "./pages/Contributions";
import DeathReports from "./pages/DeathReports";
import VoucherManagement from "./pages/VoucherManagement";
import Profile from "./pages/Profile";
import Header from "./components/Header";
import LandingPage from "./pages/LandingPage";
import Login from "./pages/Login";
import Registration from "./pages/Registration";
import ProtectedRoute from "./components/ProtectedRoute";
import SignUp from "./pages/SignUp";
import {HelmetProvider} from "react-helmet-async";
import {SEOProvider} from "./context/SEOContext";
import {DashboardSEO} from "./components/SEOPages";

// Sitemap route component
const Sitemap = () => {
    // This would be handled by your server in production
    React.useEffect(() => {
        const { generateSitemap } = require('./utils/sitemapGenerator');
        const sitemap = generateSitemap();
        // In a real app, you'd serve this via a server route
        console.log('Sitemap XML:', sitemap);
    }, []);

    return null;
};

// Robots.txt route component
const RobotsTxt = () => {
    React.useEffect(() => {
        const { generateRobotsTxt } = require('./utils/sitemapGenerator');
        const robots = generateRobotsTxt();
        console.log('Robots.txt:', robots);
    }, []);

    return null;
};

// Main App Content (only shown when authenticated)
const AppContent = () => {
    const [currentView, setCurrentView] = React.useState('dashboard');
    const { user, logout } = useAuth();

    const updateUserContributions = (amount) => {
        console.log('Updating user contributions:', amount);
    };

    const renderView = () => {
        switch (currentView) {
            case 'dashboard':
                return <Dashboard user={user} updateUserContributions={updateUserContributions} />;
            case 'members':
                return <Members />;
            case 'contributions':
                return <Contributions user={user} />;
            case 'death-reports':
                return <DeathReports />;
            case 'vouchers':
                return <VoucherManagement />;
            case 'profile':
                return <Profile user={user} />;
            default:
                return <Dashboard user={user} updateUserContributions={updateUserContributions} />;
        }
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <Header
                currentView={currentView}
                setCurrentView={setCurrentView}
                user={user}
                onLogout={logout}
            />
            <main className="container mx-auto px-4 py-8">
                {renderView()}
            </main>
        </div>
    );
};

// Main App Component
function App() {
    return (
        <HelmetProvider>
            <SEOProvider>
                <Router>
                    <AuthProvider>
                        <Routes>
                            {/* SEO Routes */}
                            <Route path="/sitemap.xml" element={<Sitemap />} />
                            <Route path="/robots.txt" element={<RobotsTxt />} />

                            <Route path="/" element={<LandingPage />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/sign-up" element={<SignUp />} />
                            <Route path="/register" element={<Registration />} />
                            <Route path="/dashboard" element={
                                <ProtectedRoute>
                                    <DashboardSEO />
                                    <AppContent />
                                </ProtectedRoute>
                            } />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </AuthProvider>
                </Router>
            </SEOProvider>
        </HelmetProvider>
    );
}

export default App;